module.exports = __webpack_public_path__ + "static/media/event-board.10ff0db9.png";